import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintEntityDetail } from './';

/**
 * @component {kat-blueprint-entity-detail-overview} KatBlueprintEntityDetailOverview Component used to place and filter components within the overview section.
 * @slot default Blueprint content for overview section.
 */
@register(KatBlueprintEntityDetail.slotMapping.overview.name)
export class KatBlueprintEntityDetailOverview extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintEntityDetail.slotMapping.overview.name,
      KatBlueprintEntityDetail.slotMapping.overview.allowed
    );
  }
}
